
<template>
      <div class="car-num car-con">
            <div class="title">
                <img src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/t1.png" alt="">
            </div>
            <div v-if="ifylxd" class="car-num-top"><i></i>每日分享
                <span class="sp2"><span class="sp3">{{shareorder.shareAmount>2?'2':shareorder.shareAmount}}</span>/2</span>
                <br><span class="sp1">(每日分享可获得抽卡机会，一天限2次)</span>
                <a data-stat="去分享" v-if="shareorder.shareAmount<2" href="ulemobile://uleHomepage">去分享</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="ifylxd" class="car-num-top car-num-bot"><i></i>每日成单
                <span class="sp2"><span class="sp3">{{shareorder.orderAmount>3?'3':shareorder.orderAmount
                     }}</span>/3</span>
                <br><span class="sp1">(每成1单可获得抽卡机会，一天限3次)</span>
                <a data-stat="去下单" v-if="shareorder.orderAmount<3" href="ulemobile://uleHomepage">去完成</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top"><i></i>每日分享
                <span class="sp2"><span class="sp3">{{ulefenx>1?'1':ulefenx}}</span>/1</span>
                <br><span class="sp1">(每日分享爽12活动可获领卡资格，一天限1次)</span>
                <a data-stat="去分享" v-if="ulefenx<1" href="//www.ule.com/app/yxd/event/2019/0730/twelve/ulewap.html">去分享</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top car-num-kan"><i></i>每日浏览
                <span class="sp2"><span class="sp3">{{ulellan>2?'1':ulellan}}</span>/1</span>
                <br><span class="sp1">(每日浏览指定商品可获领卡资格，一天限1次)</span>
                <a data-stat="去分享" v-if="ulellan<1" href="//www.ule.com/event/tmpl/ulewap.html?actId=718">去浏览</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div v-if="!ifylxd" class="car-num-top car-num-bot"><i></i>每日成单
                <span class="sp2"><span class="sp3">{{ulechengd>3?'3':ulechengd}}</span>/3</span>
                <br><span class="sp1">(每日成单可获得领卡资格，一天限3次)</span>
                <a data-stat="邮乐网去成单" v-if="ulechengd<3" href="//www.ule.com/app/yxd/event/2019/0730/twelve/ulewap.html">去下单</a>
                <a v-else　class="wanc" href="javascript:void(0);">明日再来</a>
            </div>
            <div class="car-num-top car-num-bot youxi"><i></i>每日游戏
                <br><span class="sp1">(每日玩指定游戏可获抽卡机会，一天限2次)</span>
                <a data-stat="去游戏" :href="youxilink">去游戏</a>
            </div>
        </div>
</template>

<script>
export default {
  props:['ifylxd'],
  data () {
      return {
        shareorder:'', 
         youxilinks:{
                    ule:'//h5.tom.cn/ule/game/oauth/264?channel=ule&mobile=',
                    ylxd:'//h5.tom.cn/ule/game/oauth/265?channel=ylxd&mobile='
        },
        youxilink:'//h5.tom.cn/ule/game/oauth/264?channel=ule&mobile=',
        ruleCode:['CX_QZ_TJ_157501719082053','CX_QZ_TJ_157501737672475','CX_QZ_TJ_157501749094541'],
        ulellan:'0',
        ulefenx:'0',
        ulechengd:'0',
      }
    },
    created(){
      var m=this;
      if(m.ifylxd){
          m.youxilink=m.youxilinks.ylxd;
          //  查询参加人数
       this.HTTP.qryinfobyOwner().then((res) => {
            m.shareorder = res.body.data;
        }, (err) => {
            console.log(err);
        });
      }else{
        this.HTTP.datetime().then((res) => {
                let times=this.BASE.formaDate(res.time,'yyyy-MM-dd');
                m.ulemun(times)
        },(ree) =>{

        })
      } 
    }, 
     methods:{
         ulemun(tim){
            let m=this;
            let ruleCodes=m.ruleCode.join(",")
            this.HTTP.cationByRulehttp(ruleCodes,tim).then((res) => {
            let arr=res.body.content;
            m.ulellan=arr[1].times;
            m.ulefenx=arr[0].times;
            m.ulechengd=arr[2].times;
            }, (err) => {
            console.log(err);
            });
         }
    }, 
}
</script>

<style scoped>
.car-num{
    width: 95%;
    margin: 0 auto;
    padding-bottom: .4rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
    margin-bottom: .35rem;
}
.car-con .title img{
    height: .95rem;
    width:auto;
    display: inline-block;
}
.car-num .car-num-top{
    width: 96.1%;
    margin: 0 auto;
    height: .9rem;
    color: #fff8cb;
    font-size: .22rem;
    position: relative;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/bg1.png) no-repeat center;
    background-size: 100% 100%;
    margin-bottom: .04rem;
    padding-left: 1.12rem;
    line-height: .35rem;
    padding-top: .1rem;
    box-sizing: border-box;
}
.car-num .car-num-top i{
    position: absolute;
    width: .46rem;
    height: 100%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/ion2.png) no-repeat center;
    background-size: .42rem .4rem;
    left: .36rem;
    top: 0;
}
.car-num .car-num-top.car-num-bot{
    margin-top: 0;
}
.car-num .car-num-top.car-num-bot i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/i3.png) no-repeat center;
    background-size: .45rem .45rem;
}
.car-num .car-num-top.car-num-bot.youxi i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/ion8.png) no-repeat center;
    background-size: .46rem .43rem;
}
.car-num .car-num-top.car-num-kan i{
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/i2.png) no-repeat center;
    background-size: .44rem .32rem;
}
.car-num .car-num-top .sp1{
    color: #fff8cb;
    font-size: .18rem;
}
.car-num .car-num-top .sp2{
    color: #fff8cb;
    font-size: .26rem;
    font-weight: 600;
}
.car-num .car-num-top .sp3{
    color: #ffe400;
    font-size: .26rem;
    font-weight: 600;
}
.car-num-top a{
    display: block;
    width: 1.74rem;
    height: .56rem;
    position: absolute;
    top: .17rem;
    right: .38rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/i1.png) no-repeat center;
    background-size:100% 100%;
    font-size: .22rem;
    text-align: center;
    color: #f4244b;
    line-height: .56rem;
}
.car-num-top a.wanc{
    background: url(//www.ule.com/app/yxd/event/2019/0730/douele/image/an2.png) no-repeat center;
    background-size:100% 100%;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/speed.vue